module.exports = __webpack_public_path__ + "static/media/logo-cuotaya-1.56f044b0.webp";